import React, { useState, useEffect } from 'react';
import mixpanel from "mixpanel-browser";
import { RestHelper } from '../helper/restHelper'

const NotaryCampaign = () => {
  const [showCard, setShowCard] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [apiRes, setApiRes] = useState()

  const api = RestHelper()
  const handleCloseCard = () => {
    setShowCard(false);
    sessionStorage.setItem('adClosed', 'true');
    mixpanel.track('Affiliate Campaign', { 'action': 'minimize' })
  }

  const updateCampaigm = (action) => {
    const options = {}
    const passedData = {'action' : action}
    api
      .postCreate('/campaign-manage-user', options, passedData)
      .then(res => setApiRes(res))
      .catch(err => console.log(err))
  }
  
  const handleNotInterested = () => {
    setShowCard(false)
    updateCampaigm('Decline')
    sessionStorage.setItem('adClosed', 'true');
    mixpanel.track('Affiliate Campaign', {'action': 'not_interested'})
  }

  const handleShowModal = () => {
    setShowModal(true);
    updateCampaigm('Enroll')
    mixpanel.track('Affiliate Campaign', {'action':'enroll'})
  }
  
  const handleCloseModal = () => {
    setShowModal(false);
    setShowCard(false);
    sessionStorage.setItem('adClosed', 'true');
  }

  useEffect(() => {
    mixpanel.track('Affiliate Campaign', { 'action': 'pageview' })
  }, [])

  return (
    <>
      {showCard && (
        <div className="relative bg-neutral-50 p-6 rounded-xl shadow-lg border-[3px] border-brand-blue mb-6 text-center">
          {/* Close button */}
          <button 
            onClick={handleCloseCard} 
            className="absolute top-3 right-3 p-1 text-neutral-400 hover:text-neutral-600 hover:bg-neutral-200 rounded-lg transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          
          <div className="pt-2">
            <h3 className="text-xl font-bold text-neutral-800 mb-3">Want to Earn More in 2026?</h3>
            <p className="text-neutral-600 mb-4">
              Announcing the Pinpoint Field Services Affiliate Program! Help us grow and 
              get rewarded for referrals.
            </p>
            <div className="flex justify-center gap-3">
              <button
                onClick={handleShowModal}
                className="btn btn-primary"
              >
                Learn More
              </button>
              <button
                onClick={handleNotInterested}
                className="btn btn-secondary"
              >
                Not Interested
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          {/* Backdrop */}
          <div 
            className="fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity"
            onClick={handleCloseModal}
          />
          
          {/* Modal content */}
          <div className="flex min-h-full items-center justify-center p-4">
            <div className="relative bg-white rounded-2xl shadow-xl max-w-md w-full transform transition-all">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-neutral-200">
                <h3 className="text-lg font-semibold text-neutral-900">Thank You!</h3>
                <button
                  onClick={handleCloseModal}
                  className="p-1 rounded-lg text-neutral-400 hover:text-neutral-600 hover:bg-neutral-100 transition-colors"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              {/* Body */}
              <div className="px-6 py-5">
                <p className="text-neutral-600">
                  Thank you for your interest! Please check your inbox for an email with more details.
                </p>
              </div>

              {/* Footer */}
              <div className="flex items-center justify-end gap-3 px-6 py-4 bg-neutral-50 rounded-b-2xl">
                <button
                  onClick={handleCloseModal}
                  className="btn btn-primary"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NotaryCampaign;
